import { Link } from 'react-router-dom';
import CustomAILogo from '../CustomAILogo';
import { CONTACT_EMAIL, CONTACT_PHONE, ADDRESS, COMPANY_LEGAL, COMPANY_ABN } from '@/lib/constants';

const footerLinks = {
  products: [
    { name: 'AI Sales Assistant', path: '/services/' },
    { name: 'AI Customer Excellence', path: '/services/' },
    { name: 'AI Chatbot', path: '/services/' },
    { name: 'AI Messaging Service', path: '/services/'},
    { name: 'Custom Dashboard', path: '/services/' },
  ],
  company: [
    /* About Page blocked out until redesigned. */
    /* { name: 'About Us', path: '/about' }, */
    { name: 'Services', path: '/services/' },
    { name: 'FAQ', path: '/faq/' },
    { name: 'Training Workshop', path: '/training-workshop/' },
  ],
  contact: [
    { name: `${CONTACT_EMAIL}`, path: `mailto:${CONTACT_EMAIL}`, external: true },
    { name: `${CONTACT_PHONE}`, path: `tel:${CONTACT_PHONE.replace(/[^+\d]/g, '')}`, external: true },
    { name: 'Book a Call', path: '/contact/' },
    { name: 'Support', path: '/contact/' },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-brand-black" style={{ borderTop: '1px solid var(--brand-border)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <CustomAILogo to="/" height={30} />
            </div>
            <p className="text-sm text-brand-muted leading-relaxed">
              The AI infrastructure behind your business growth. Deploy intelligent AI agents managed by our team.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-muted mb-5">Products</h4>
            <ul className="space-y-3">
              {footerLinks.products.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-brand-muted hover:text-brand-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-muted mb-5">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-brand-muted hover:text-brand-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-brand-muted mb-5">Contact</h4>
            <ul className="space-y-3">
              {footerLinks.contact.map((link) => (
                <li key={link.name}>
                  {link.external ? (
                    <a href={link.path} className="text-sm text-brand-muted hover:text-brand-white transition-colors">
                      {link.name}
                    </a>
                  ) : (
                    <Link to={link.path} className="text-sm text-brand-muted hover:text-brand-white transition-colors">
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Map */}
          <div>
            <div className="w-full aspect-square rounded-2xl overflow-hidden" style={{ border: '1px solid var(--brand-border)' }}>
              <iframe
                title="Custum AI location"
                src={`https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <p className="text-xs text-brand-muted mt-3">
              {ADDRESS}
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" style={{ borderTop: '1px solid var(--brand-border)' }}>
          <p className="text-xs text-brand-muted text-center md:text-left">
            &copy; {new Date().getFullYear()} custum.ai. All rights reserved.
            <br />
            custum.ai is a trading name of {COMPANY_LEGAL} &nbsp;&middot;&nbsp; ABN {COMPANY_ABN}
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy/" className="text-xs text-brand-muted hover:text-brand-white transition-colors">Privacy Policy</Link>
            <Link to="/terms/" className="text-xs text-brand-muted hover:text-brand-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
